/* eslint-disable jsx-a11y/anchor-is-valid */
import React,{ useState,useEffect } from "react"; 
import { Link, Outlet } from "react-router-dom";

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../../components/recoil/atoms/Menus";
import MenuBranch from "./MenuBranch";

import centerlogoImage from "../../../img/logo/logo-partner.svg";
import menuIcon from "../../../img/icon/icon-left-menu.svg";

import "../../../css/style.css";

const BranchFlatForm = () => {

  const [varBranchMenus] = useRecoilState(BranchMenus);

  //좌측메뉴 열기/닫기
  const [varMenuState,setMenuState] = useState(false);

  useEffect(() => {
    //페이지 크기 재설정
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
    window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', vh + 'px');
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="vh-container">
      <header className="center-header">
        {!varBranchMenus.showMenu?null:
          <div className="gnb-menu-tirgger" onClick={()=>setMenuState(true)}>
            <img src={menuIcon} alt=""/>
          </div>			
        }
        {varBranchMenus.gotoMain===-1?<div className="hd-logo"><img src={centerlogoImage} alt="" /></div>
        :varBranchMenus.gotoMain===0||varBranchMenus.gotoMain===1?<Link to={'/MainBranch'} className="hd-logo"><img src={centerlogoImage} alt="" /></Link>
        :<div className="hd-logo"><img src={centerlogoImage} alt="" /></div>
        }
      </header>
      <Outlet/>
      {/* 좌측메뉴 */}
      <div className="layer-bg"></div>
      <MenuBranch varMenuState={varMenuState} setMenuState={setMenuState}/>
    </div>
  );
}
export default BranchFlatForm;